module.exports = __webpack_public_path__ + "static/media/ic_recommend.99851f05.svg";